var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Screen',[_c('AppBar',{attrs:{"title":_vm.title,"showBackButton":false}}),_vm._v(" "),_c('Breadcrumbs',{attrs:{"title":_vm.title}}),_vm._v(" "),_c('iframe',{staticClass:"card card-body p-0",attrs:{"src":_vm.url,"frameborder":"0"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }